<div class="cmx-tooltip"
    [ngClass]="tooltipClass"
    [ngStyle]="tooltipStyle"
    [attr.dir]="rtl? 'rtl' : 'ltr'" 
    [innerHTML]="options.content">

</div>
